import * as React from 'react'

export const Waiting = () => <div>Loading provider... please wait.</div>;